/* eslint-disable class-methods-use-this */

import { Controller } from 'stimulus';
import toArray from '../helpers/toArray';

class ContactMap extends Controller {
  onPinClick(event) {
    const target = event.currentTarget;
    const popup = this.findPopupForToggleElement(target);

    this.closeOpenPopups();
    this.togglePopup(popup);
  }

  onCloseClick(event) {
    const target = event.currentTarget;
    const popup = this.findPopupForToggleElement(target);

    this.togglePopup(popup);
  }

  closeOpenPopups() {
    this.popupTargets.forEach((popupTarget) => {
      if (popupTarget.getAttribute('aria-hidden') === 'false') {
        this.togglePopup(popupTarget);
      }
    });
  }

  findPopupForToggleElement(toggleElement) {
    const controlsId = toggleElement.getAttribute('aria-controls');
    const popup = document.getElementById(controlsId);

    if (!popup) {
      throw new Error(`Popup for ID ${controlsId} not found`);
    }

    return popup;
  }

  togglePopup(popup) {
    const isOpen = popup.getAttribute('aria-hidden') === 'false';

    popup.setAttribute('aria-hidden', isOpen ? 'true' : 'false');

    const popupId = popup.id;

    const toggles = toArray(document.querySelectorAll(`[aria-controls="${popupId}"]`));

    toggles.forEach((toggle) => {
      toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    });
  }
}

ContactMap.targets = [
  'holder',
  'popup',
];

export default ContactMap;
